import { useState } from "react";
import { updateFile as updateNoteTemplateService } from "@/services/files";
import type { IUseUpdateTemplate } from "../notesTemplates/useUpdateTemplateFactory";
import type { BodyUpdateTemplate } from "@/common/types/notesTemplates";

export const useUpdateVisitTemplate = (): IUseUpdateTemplate => {
  const [result, setResult] = useState<boolean | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const updateTemplate = async (body: BodyUpdateTemplate): Promise<void> => {
    setLoading(true);
    setError(false);
    try {
      await updateNoteTemplateService({ fileId: body.id, result: body.result });
      setResult(true);
    } catch {
      setResult(false);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  return { updateTemplate, result, loading, error };
};
